module.exports = "//static.hsappstatic.net/ComposeUI/static-1.9550/img/failed-image-upload.png"